<script lang="ts">
    import { isLogin } from '../store/index';

    import PhoneInput from './PhoneInput.svelte';
</script>

<div class="phone-module">
    {#if !$isLogin}
        <div class="title">Ingresa tu número de celular</div>
    {/if}
    <PhoneInput />
</div>

<style lang="scss">
    .phone-module {
        background: #ffffff;
        color: #0b0b0d;

        .title {
            margin: 60px 0 0 40px;
            font-family: DiDiSans-Pro-Bold;
            font-size: 32px;
            letter-spacing: 0px;
            color: #000000;
        }
    }
</style>
